import cn from 'classnames'
import { LinkProps } from 'next/link'
import React from 'react'
import { Tab, TabProps } from './Tab'

export enum TabsView {
	default = 'default',
	popup = 'popup',
	contained = 'contained',
}

type TabsItem = {
	label: TabProps['label']
	linkProps?: LinkProps
}

interface TabsProps {
	items: TabsItem[]
	onChange: (selectedIndex: number) => void
	view?: TabsView
	initialIndex?: number
}

export const Tabs: React.FunctionComponent<TabsProps> = ({
	items,
	onChange,
	view,
	initialIndex = 0,
}) => {

	const generateHash = (item : TabsItem) => {
		const hash = 'tab-' + encodeURIComponent(
			item.label.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, "").split(' ').join('+')
		);

		return hash;
	}

	const setIndex = (index : number) => {
		if (index !== selected) {
			setSelected(index)
			onChange(index)

			const item = items[index];
			const hash = generateHash(item);
			if(globalThis.window && window.location.hash != hash)
			{
				//window.location.hash = hash;
			}
		}
	}

	const checkHash = () => {
		const hash = window.location.hash.trim().replace('#', '');
		if(hash.length)
		{
			for(const index in items)
			{
				const i = parseInt(index);
				if(generateHash(items[i]) == hash)
				{
					console.log('Switching tabs...');
					setIndex(i);
				}
			}
		}
	}

	const [selected, setSelected] = React.useState(initialIndex)
	const onClick = React.useCallback(
		(index: number) => () => {
			setIndex(index);
		},
		[onChange, selected, setSelected],
	)

	React.useEffect(() => {
		if(globalThis.window)
		{
			checkHash();

			window.removeEventListener('hashchange', checkHash);
			window.addEventListener('hashchange', checkHash);
		}
	}, []);

	return (
		<div className={cn('tabs', `view-${view}`)}>
			{items.map((item, i) => (
				<Tab
					key={i}
					active={i === selected}
					label={item.label}
					linkProps={item.linkProps}
					onClick={onClick(i)}
					view={view}
				/>
			))}
		</div>
	)
}
